'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PercentStackedValuesCheckbox = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PercentStackedValuesCheckbox = function PercentStackedValuesCheckbox(refs) {
    var i18n = refs.i18nManager.get();

    return Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.use_percent_stacked_values,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px'
    });
};

exports.PercentStackedValuesCheckbox = PercentStackedValuesCheckbox;
exports.default = PercentStackedValuesCheckbox;
//# sourceMappingURL=PercentStackedValues.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/PercentStackedValues.js
 ** module id = 357
 ** module chunks = 0
 **/